var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 100.656C200 74.1346 189.464 48.6992 170.711 29.9456C151.957 11.1919 126.522 0.656252 100 0.65625C73.4784 0.656248 48.043 11.1919 29.2893 29.9456C10.5357 48.6992 4.00466e-06 74.1346 0 100.656L100 100.656H200Z",
    fill: "#F6EFE9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_584_19658)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.656,
    r: 50,
    fill: "#9C4900"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.26 80.6562C112.32 80.6562 121.28 89.6562 121.28 100.656C121.28 111.656 112.32 120.656 101.26 120.656C94.24 120.656 88.1 117.016 84.52 111.516L87.68 109.016C90.5 113.596 95.52 116.656 101.28 116.656C105.523 116.656 109.593 114.971 112.594 111.97C115.594 108.969 117.28 104.9 117.28 100.656C117.28 96.4128 115.594 92.3431 112.594 89.3425C109.593 86.342 105.523 84.6562 101.28 84.6562C93.12 84.6562 86.4 90.7762 85.42 98.6562H90.94L83.46 106.116L76 98.6562H81.38C82.38 88.5562 90.9 80.6562 101.26 80.6562ZM107.18 97.1362C108.18 97.1562 109 97.9562 109 98.9762V108.196C109 109.196 108.18 110.036 107.16 110.036H96.1C95.08 110.036 94.26 109.196 94.26 108.196V98.9762C94.26 97.9562 95.08 97.1562 96.08 97.1362V95.1162C96.08 92.0562 98.58 89.5763 101.62 89.5763C104.68 89.5763 107.18 92.0562 107.18 95.1162V97.1362ZM101.62 92.3763C100.12 92.3763 98.88 93.5962 98.88 95.1162V97.1362H104.38V95.1162C104.38 93.5962 103.14 92.3763 101.62 92.3763Z",
    fill: "#F6EFE9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_584_19658",
    x: 44,
    y: 44.6562,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.845833 0 0 0 0 0.842309 0 0 0 0 0.84363 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_584_19658"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_584_19658",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.2d1d1f6c50c9340e0bcb3b7bc442ba71.svg";
export { ForwardRef as ReactComponent };